export const DASH = {


    REQUEST_LOGIN: "REQUEST_LOGIN",
    SUCCESS_LOGIN: "SUCCESS_LOGIN",
    FAILED_LOGIN: "FAILED_LOGIN",

    REQUEST_TOKEN: "REQUEST_TOKEN",
    SUCCESS_TOKEN: "SUCCESS_TOKEN",
    FAILED_TOKEN: "FAILED_TOKEN",
  
}